import { PropsWithChildren } from 'react';

interface Props {
	src: HTMLImageElement['src'];
}

const Illustration = ({ src }: PropsWithChildren<Props>) => {
	return <img src={src} style={{ width: '100%', height: '100%' }} />;
};

export default Illustration;
